// prevent scroll
if (location.hash) {
    window.scrollTo(0, 0);
    setTimeout(function () {
        window.scrollTo(0, 0);
    }, 1);
}

$(document).foundation();

$(document).ready(function () {
    inlineSVGs(['.header__icons img']);
    initCookieMessage();
    initHeader();
    initFooter();
    initNavigation();
    initSubNavigation();
    initSliders();
    initDatePickers();
    initMaps();
    Multiselect.init();
    initPropertyListing();
    initContactForm();
    initFavourites();
    initHero();
    initIntro();
    initSliderVideo();
    initGallery();
    initRatesTables();
    initVideos();
    initYourStay();
    initVpCenter();
});

var config = (function () {
    var params = new URLSearchParams(window.location.search);

    // default config
    var configObj = {
        culture: 'en-GB',
        availabilityCalendar: {
            unit: 'night',
            unitPlural: 'nights',
            openButtonText: 'Open calendar'
        },
        pdfMode: params.get('pdf') === 'true'
    }

    var configJson = document.getElementById('site-config');

    if (configJson) {
        var siteConfig = JSON.parse(configJson.innerText);
        Object.assign(configObj, siteConfig);

        // specify language cultures if not set
        if (configObj.culture === 'fr') {
            configObj.culture === 'fr-FR'
        }
        if (configObj.culture === 'en') {
            configObj.culture === 'en-GB'
        }
    }

    return configObj;
})();

var printWatcher = (function () {
    var callbacks = [];
    // check for print media query
    var mq = window.matchMedia('print');
    // execute callbacks on media query change
    // chrome and edge fire this a lot, future callbacks using these methods may need debouncing
    mq.onchange = function () {
        callbacks.forEach(function (callback) {
            callback(mq.matches);
        });
    };
    // execute callbacks on page load
    window.onload = function () {
        callbacks.forEach(function (callback) {
            callback(mq.matches);
        });
    };
    // push registered callbacks into collection
    return {
        onChange: function (callback) {
            callbacks.push(callback);
        }
    };
})();

var tabWatcher = (function () {
    return {
        onChange: function (el, callback) {
            // check if element is in a tab.
            var tab = el.closest('.tabs-panel');
            if (tab) {
                // Foundation's tab API is tied to the tab bar, not the tab content, this is a workaround.
                var observer = new MutationObserver(function (mutationList) {
                    mutationList.forEach(function (mutation) {
                        if (mutation.attributeName === 'class' && mutation.target.classList.contains('is-active')) {
                            callback();
                        }
                    });
                });
                // watch for the tab content class change
                observer.observe(tab, { attributes: true, attributeFilter: ['class'] });
            }
        }
    };
})();

// https://stackoverflow.com/questions/24933430/img-src-svg-changing-the-fill-color
function inlineSVGs(inputValue) {
    var selectorString = '';
    if (typeof inputValue === 'object') {
        selectorString = inputValue.join(',');
    } else {
        selectorString = inputValue;
    }

    $(selectorString).each(function () {
        var $img = $(this);
        var imgID = $img.attr('id');
        var imgClass = $img.attr('class');
        var imgURL = $img.attr('src');

        if (imgURL.indexOf('.svg') > -1) {
            $.get(
                imgURL,
                function (data) {
                    // Get the SVG tag, ignore the rest
                    var $svg = $(data).find('svg');

                    // Add replaced image's ID to the new SVG
                    if (typeof imgID !== 'undefined') {
                        $svg = $svg.attr('id', imgID);
                    }
                    // Add replaced image's classes to the new SVG
                    if (typeof imgClass !== 'undefined') {
                        $svg = $svg.attr('class', imgClass + ' replaced-svg');
                    }

                    // Remove any invalid XML tags as per http://validator.w3.org
                    $svg = $svg.removeAttr('xmlns:a');

                    // Check if the viewport is set, if the viewport is not set the SVG wont't scale.
                    if (!$svg.attr('viewBox') && $svg.attr('height') && $svg.attr('width')) {
                        $svg.attr('viewBox', '0 0 ' + $svg.attr('height') + ' ' + $svg.attr('width'));
                    }

                    // Replace image with new SVG
                    $img.replaceWith($svg);
                },
                'xml'
            );
        }
    });
}

function initCookieMessage() {
    // check if cookie message has already been accepted
    if (Cookies.get('cookie-message') === 'accepted') {
        return;
    }

    // initialise the cookie message
    $('.cookie')
        .on('click', function () {
            // set cookie to confirm message was accepted
            Cookies.set('cookie-message', 'accepted', { expires: 30 });

            // hide message
            $(this).removeClass('cookie--active');
        })
        .addClass('cookie--active');
}

function initHeader() {
    var stickAtOffset = 25;
    var stuck = false;
    var stuckClass = 'header--stuck';
    var headerMenuOpenClass = 'header--menu-open';

    var $header = $('header.header');
    var $navToggle = $('#navigation-toggle');

    function stickHeader() {
        if (stuck === false && window.pageYOffset > stickAtOffset) {
            stuck = true;
            $header.addClass(stuckClass);
        } else if (stuck === true && window.pageYOffset < stickAtOffset) {
            stuck = false;
            $header.removeClass(stuckClass);
        }
    }

    stickHeader();

    $(window).on('scroll', function () {
        stickHeader();
    });

    $navToggle.on('toggled.zf.responsiveToggle', function () {
        $header.toggleClass(headerMenuOpenClass);

    });

    $(window).on('changed.zf.mediaquery', function (e, newSize) {
        if (newSize === 'large') {
            $header.removeClass(headerMenuOpenClass);
        }
    });
}

function initFooter() {
    // fix the sticky book now button when the footer "about" menu is opened
    $('.footer__links button[data-toggle="footer-links"]').on('click', function () {
        setTimeout(function () {
            $(window).trigger('resize');
            // Scroll to the bottom to reveal the full menu
            $('html, body').animate({ scrollTop: $('#footer-links').offset().top + 120 * 1 }, 500);
        }, 100);
    });
}

function initNavigation() {
    // stop body from scrolling when burger menu or property filters are open (copied from Foundation off-canvas)
    var stopScrolling = function (e) {
        e.preventDefault();
    };

    var recordScrollable = function (e) {
        if (this.scrollHeight !== this.clientHeight) {
            if (this.scrollTop === 0) {
                this.scrollTop = 1;
            }
            if (this.scrollTop === this.scrollHeight - this.clientHeight) {
                this.scrollTop = this.scrollHeight - this.clientHeight - 1;
            }
        }
        this.allowUp = this.scrollTop > 0;
        this.allowDown = this.scrollTop < this.scrollHeight - this.clientHeight;
        this.lastY = e.originalEvent.pageY;
    };

    var stopScrollPropagation = function (e) {
        var up = e.pageY < this.lastY;
        var down = !up;
        this.lastY = e.pageY;

        if ((up && this.allowUp) || (down && this.allowDown)) {
            e.stopPropagation();
        } else {
            e.preventDefault();
        }
    };

    $('body')
        .on('on.zf.toggler', function () {
            $(this).on('touchmove', stopScrolling);
            $('#navigation')
                .on('touchstart', recordScrollable)
                .on('touchmove', stopScrollPropagation);
        })
        .on('off.zf.toggler', function () {
            $(this).off('touchmove', stopScrolling);
            $('#navigation')
                .off('touchstart', recordScrollable)
                .off('touchmove', stopScrollPropagation);
        });
}

function initSubNavigation() {
    // toggle sub navigation dropdown on mobile
    if (Foundation.MediaQuery.is('small') || Foundation.MediaQuery.is('medium')) {
        $('.sub-navigation__list .sub-navigation__item').on('click', function (e) {
            var item = $(this);

            item.closest('.sub-navigation__list').toggleClass('sub-navigation__list--active');

            if (item.hasClass('is-active')) {
                e.preventDefault();
                return false;
            }
        });
    }
}

function initSliders() {
    // turn off entirely for PDF generation, to avoid empty pages at the end
    if (config.pdfMode) {
        return;
    }

    var slickOptions = {
        prevArrow: '<button type="button" class="slick-prev"></button>',
        nextArrow: '<button type="button" class="slick-next"></button>'
    };

    var initialized = false;

    function buildSliders() {
        $('[data-slick]').slick(slickOptions).each(function () {
            var slider = $(this);

            // recalculate slider position if shown in a tab
            tabWatcher.onChange(this, function () {
                slider.slick('setPosition');
            });
        });

        $('.slider__scroll').on('click', function () {
            // scroll down to main content
            $('html, body').animate(
                {
                    scrollTop: $(this)
                        .prev('.slider')
                        .outerHeight()
                },
                500
            );
        });

        // Manual pagination for this module
        $('.grid-feature-text-image-paged').each(function () {
            var slider = $(this).find('.grid-feature-text-image-paged__slider');
            var count = 0;
            var total = slider.find('.grid-feature-text-image-paged__slide').length;

            if (total > 1) {
                slider.find('.grid-feature-text-image-paged__slide').each(function () {
                    if (slider.data('dots')) {
                        var dots = '<div class="grid-feature-text-image-paged__dots">';
                        for (var i = 0; i < total; i++) {
                            if (count === i) {
                                dots += '<button class="active" data-goto="' + i + '">' + i + '</button>';
                            } else {
                                dots += '<button data-goto="' + i + '">' + i + '</button>';
                            }
                        }
                        dots += '</div>';

                        $(this)
                            .find('.grid-feature-text-image-paged__text.small-12')
                            .append(dots);
                    }

                    count++;
                });
            }
        });

        $('.grid-feature-text-image-paged__prev').on('click', function () {
            $(this)
                .parents('.grid-feature-text-image-paged__slider')
                .slick('slickPrev');
        });

        $('.grid-feature-text-image-paged__next').on('click', function () {
            $(this)
                .parents('.grid-feature-text-image-paged__slider')
                .slick('slickNext');
        });

        $('.grid-feature-text-image-paged__dots button').on('click', function () {
            $(this)
                .parents('.grid-feature-text-image-paged__slider')
                .slick('slickGoTo', $(this).data('goto'));
        });

        // toggle second intro text block
        $('.grid-feature-text-image-paged__more button').on('click', function () {
            var btn = $(this);
            var div = btn.parent('.grid-feature-text-image-paged__more');
            var showLess = !div.hasClass('grid-feature-text-image-paged__more--less');
            div.prev('.grid-feature-text-image-paged__text').toggleClass('grid-feature-text-image-paged__text--more');
            div.toggleClass('grid-feature-text-image-paged__more--less');
            btn.text(showLess ? btn.data('less') : btn.data('more'));
        });

        initialized = true;
    }

    function destroySliders() {
        if (initialized) {
            $('[data-slick]').slick('unslick');
            initialized = false;
        }
    }

    printWatcher.onChange(function (isPrint) {
        if (isPrint) {
            destroySliders();
        } else {
            buildSliders();
        }
    });
}

function initDatePickers() {
    var easepickButtons = {
        nextMonthButton: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M342.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L274.7 256 105.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"/></svg>',
        prevMonthButton: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M41.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 256 278.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"/></svg>',
        resetButton: '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-calendar-x" viewBox="0 0 16 16"><path d="M6.146 7.146a.5.5 0 0 1 .708 0L8 8.293l1.146-1.147a.5.5 0 1 1 .708.708L8.707 9l1.147 1.146a.5.5 0 0 1-.708.708L8 9.707l-1.146 1.147a.5.5 0 0 1-.708-.708L7.293 9 6.146 7.854a.5.5 0 0 1 0-.708z"/><path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z"/></svg>'
    };

    $.fn.easepick = function (options) {
        var existing = $(this).data("_easepick");
        if (existing) {
            return existing;
        }

        var settings = Object.assign({
            element: this[0],
            css: ['/assets/eden-rock-vendor.css'],
            lang: config.culture,
            format: 'DD/MM/YYYY',
            zIndex: 200,
            pending: [],
            unavailable: [],
            plugins: [
                'RangePlugin',
                'LockPlugin',
                'KbdPlugin',
                'AmpPlugin'
            ],
            locale: {
                nextMonth: easepickButtons.nextMonthButton,
                previousMonth: easepickButtons.prevMonthButton,
                resetButton: easepickButtons.resetButton
            },
            AmpPlugin: {
                resetButton: true,
                darkMode: false
            },
            KbdPlugin: {
                unitIndex: 0,
                dayIndex: 0,
                html: '\
                <style>\
                    button {\
                        background-image: url("/assets/img/eden-rock/calendar.png");\
                        background-color: transparent;\
                        background-size: 14px 15px;\
                        background-position: 2px center;\
                        background-repeat: no-repeat;\
                        border: none;\
                        width: 25px;\
                        height: 2.87692rem;\
                    }\
                </style>\
                <button class="sr-only" title="' + config.availabilityCalendar.openButtonText + '"></button> \
                '
            },
            LockPlugin: {
                minDate: new Date(),
                filter: function (date) {
                    return isPending(date) || isUnavailable(date);
                },
                minDays: 2,
                inseparable: true
            },
            RangePlugin: {
                tooltipNumber: function (num) {
                    return num - 1;
                },
                locale: {
                    one: config.availabilityCalendar.unit,
                    other: config.availabilityCalendar.unitPlural,
                }
            },
            setup: function (picker) {
                picker.on('view', function (e) {
                    var rangeInfo = {};
                    if (e.detail.view === 'CalendarDayName') {
                        e.detail.target.textContent = e.detail.target.textContent.substring(0, 2);
                    }
                    if (e.detail.view === 'CalendarDay') {
                        if (isUnavailable(e.detail.date, rangeInfo)) {
                            if (rangeInfo.first === rangeInfo.last) {
                                e.detail.target.classList.add('unavailable');
                            } else {
                                if (rangeInfo.first) {
                                    e.detail.target.classList.add('unavailable-first');
                                }
                                if (rangeInfo.last) {
                                    e.detail.target.classList.add('unavailable-last');
                                }
                            }
                        }
                        if (isPending(e.detail.date, rangeInfo)) {
                            if (rangeInfo.first === rangeInfo.last) {
                                e.detail.target.classList.add('pending');
                            } else {
                                if (rangeInfo.first) {
                                    e.detail.target.classList.add('pending-first');
                                }
                                if (rangeInfo.last) {
                                    e.detail.target.classList.add('pending-last');
                                }
                            }
                        }
                    }
                });
            }
        }, options);

        function isPending(date, rangeInfo) {
            var str = date ? date.format('YYYY-MM-DD') : null;
            return settings.pending.some(function (range) {
                if (rangeInfo) {
                    if (str == range[0]) {
                        rangeInfo.first = true;
                    }
                    if (str == range[1]) {
                        rangeInfo.last = true;
                    }
                    return str >= range[0] && str <= range[1];
                }
                return str > range[0] && str < range[1];
            });
        }

        function isUnavailable(date, rangeInfo) {
            var str = date ? date.format('YYYY-MM-DD') : null;
            return settings.unavailable.some(function (range) {
                if (rangeInfo) {
                    if (str == range[0]) {
                        rangeInfo.first = true;
                    }
                    if (str == range[1]) {
                        rangeInfo.last = true;
                    }
                    return str >= range[0] && str <= range[1];
                }
                return str > range[0] && str < range[1];
            });
        }

        var ep = new easepick.create(settings);
        $(this).data("_easepick", ep);
        return ep;
    }
}

function initMaps() {
    $.fn.leaflet = function (markers, isMarkerValid) {
        var mapSettings = this.data('map')
        var inside = false;
        var padding = inside ? [100, 100] : [-250, -250];

        // this could be slightly different to the image bounds, but for now its set to the same
        var mapBounds = mapSettings.bounds;

        var map = L.map(this[0], {
            maxZoom: 16,
            zoom: 13,
            zoomSnap: 1,
            zoomDelta: 1,
            center: mapSettings.center,
            scrollWheelZoom: false,
            maxBoundsViscosity: 1,
            maxBounds: mapBounds,
            attributionControl: false,
            zoomControl: false,
            gestureHandling: true,
            gestureHandlingOptions: {
                duration: 0
            }
        });

        map.fitBounds(mapBounds);

        map.setMinZoom(map.getBoundsZoom(mapBounds, inside));

        var defaultZoom = map.getBoundsZoom(mapBounds, inside, padding);

        map.setZoom(defaultZoom);

        map.setView(mapSettings.center, defaultZoom);

        L.control
            .zoom({ position: 'bottomright' })
            .addTo(map);

        L.imageOverlay(mapSettings.map, mapSettings.bounds).addTo(map);

        var markerIcons = {
            default: L.icon({
                iconUrl: '/assets/img/eden-rock/maps/pin-default.svg',
                iconSize: [20, 30],
                iconAnchor: [10, 30]
            }),
            defaultSelected: L.icon({
                iconUrl: '/assets/img/eden-rock/maps/pin-selected.svg',
                iconSize: [20, 30],
                iconAnchor: [10, 30]
            }),
            branded: L.icon({
                iconUrl: '/assets/img/eden-rock/maps/pin-branded.svg',
                iconSize: [46, 66],
                iconAnchor: [23, 66]
            }),
            airport: L.icon({
                iconUrl: '/assets/img/eden-rock/maps/poi-airport.svg',
                iconSize: [30, 30],
                iconAnchor: [15, 15]
            }),
            beach: L.icon({
                iconUrl: '/assets/img/eden-rock/maps/poi-beach.svg',
                iconSize: [30, 30],
                iconAnchor: [15, 15]
            }),
            gasStation: L.icon({
                iconUrl: '/assets/img/eden-rock/maps/poi-gas-station.svg',
                iconSize: [30, 30],
                iconAnchor: [15, 15]
            }),
            hike: L.icon({
                iconUrl: '/assets/img/eden-rock/maps/poi-hike.svg',
                iconSize: [30, 30],
                iconAnchor: [15, 15]
            }),
            hospital: L.icon({
                iconUrl: '/assets/img/eden-rock/maps/poi-hospital.svg',
                iconSize: [30, 30],
                iconAnchor: [15, 15]
            }),
            pharmacy: L.icon({
                iconUrl: '/assets/img/eden-rock/maps/poi-pharmacy.svg',
                iconSize: [30, 30],
                iconAnchor: [15, 15]
            }),
            restaurant: L.icon({
                iconUrl: '/assets/img/eden-rock/maps/poi-restaurant.svg',
                iconSize: [30, 30],
                iconAnchor: [15, 15]
            }),
            shopping: L.icon({
                iconUrl: '/assets/img/eden-rock/maps/poi-shopping.svg',
                iconSize: [30, 30],
                iconAnchor: [15, 15]
            }),
            viewPoint: L.icon({
                iconUrl: '/assets/img/eden-rock/maps/poi-view-point.svg',
                iconSize: [30, 30],
                iconAnchor: [15, 15]
            }),
            watersports: L.icon({
                iconUrl: '/assets/img/eden-rock/maps/poi-watersports.svg',
                iconSize: [30, 30],
                iconAnchor: [15, 15]
            })
        }

        var markerCluster = L.markerClusterGroup({
            showCoverageOnHover: false,
            maxClusterRadius: 80,
            iconCreateFunction: function (cluster) {
                return L.divIcon({
                    html: cluster._childCount,
                    className: 'marker-cluster',
                    iconSize: L.point(30, 44)
                });
            }
        });

        var poiCluster = L.markerClusterGroup({
            showCoverageOnHover: false,
            maxClusterRadius: 40,
            iconCreateFunction: function (cluster) {
                return L.divIcon({
                    html: cluster._childCount,
                    className: 'marker-cluster marker-cluster--poi',
                    iconSize: L.point(30, 30)
                });
            }
        });

        markers.forEach(function (options) {
            options.icon = options.icon || 'default';

            var marker = L.marker([options.position.lat, options.position.lon], {
                type: options.icon,
                icon: markerIcons[options.icon]
            });

            marker.id = options.id;
            marker.data = options.data || {};

            // cluster markers except branded
            if (options.icon == 'branded') {
                marker.addTo(map);
            } else if (options.icon == 'default') {
                markerCluster.addLayer(marker);
            } else {
                poiCluster.addLayer(marker);
            }

            if (options.popup) {
                var popup = L.popup({
                    offset: [0, -24],
                    autoPanPaddingTopLeft: [40, 0],
                    autoPanPaddingBottomRight: [0, 100]
                });

                popup.setContent(options.popup[0]);

                marker.bindPopup(popup);

                marker.on('popupopen', function (e) {
                    if (marker.options.icon == 'default') {
                        marker.setIcon(markerIcons['defaultSelected']);
                    }

                    // on mobile increase the map height to fit the whole popup
                    var popupHeight = e.popup._container.offsetHeight;

                    var mapHeight = map._container.offsetHeight;

                    if (popupHeight > mapHeight) {
                        map._container.style.minHeight = popupHeight + 40 + 'px';
                    }

                    // make sure that map bounds are big enough to fit popup as well
                    var popupPixels = map.project(e.popup.getLatLng());

                    var popupSouthWest = map.unproject([popupPixels.x - e.popup._container.offsetLeft, popupPixels.y]);

                    var popupNorthEast = map.unproject([popupPixels.x + e.popup._container.offsetLeft, popupPixels.y + e.popup._container.offsetTop - 40]);

                    var popupBounds = new L.LatLngBounds(popupSouthWest, popupNorthEast);

                    var extendedBounds = new L.LatLngBounds(mapBounds).extend(popupBounds);

                    map.setMaxBounds(extendedBounds);

                    e.popup._adjustPan();
                });

                marker.on('popupclose', function (e) {
                    if (marker.options.icon == 'default') {
                        marker.setIcon(markerIcons['default']);
                    }

                    // reset back to normal map bounds
                    map._container.style.minHeight = null;

                    map.setMaxBounds(mapBounds);

                    map.invalidateSize();
                });
            }
        });

        map.addLayer(markerCluster);

        map.addLayer(poiCluster);

        map.eachLayer(function (layer) {
            layer.on('unspiderfied', function (e) {
                e.cluster.setOpacity(e.cluster.valid ? 1 : 0.5);
            });
        });

        map._resize = function () {
            map.invalidateSize({ animate: false });
            defaultZoom = map.getBoundsZoom(mapBounds, inside, padding);
            map.setMinZoom(map.getBoundsZoom(mapBounds, inside));
            map.setView(mapSettings.center, defaultZoom);
        };

        map._validateMarkers = function () {
            if (isMarkerValid) {
                map.eachLayer(function (layer) {
                    if (layer instanceof L.MarkerCluster) {
                        // filter markers within the cluster
                        var markers = layer.getAllChildMarkers();

                        layer.valid = markers.length == 0;

                        markers.forEach(function (marker) {
                            var valid = isMarkerValid(marker);
                            marker.closePopup();
                            marker.setOpacity(valid ? 1 : 0.5);
                            layer.valid = layer.valid || valid;
                        });

                        // set cluster opacity if all markers are invalid
                        layer.setOpacity(layer.valid ? 1 : 0.5);
                    } else if (layer instanceof L.Marker) {
                        var valid = isMarkerValid(layer);
                        layer.closePopup();
                        layer.setOpacity(valid ? 1 : 0.5);
                    }
                });
            }
        };

        // re-evaluate the validity of the clusters on zoom
        map.on('zoomend', function () {
            map._validateMarkers();
        });

        return map;
    }

    $('.property-map').each(function () {
        var $key = $(this).find('.property-map__key');
        var $map = $(this).find('.property-map__map');
        var $markers = $(this).find('.property-map__marker');

        var markers = $map.data('map').markers || [];

        // get markers with popups
        if ($markers.length) {
            markers = markers.concat($markers.map(function () {
                return {
                    icon: $(this).data('icon'),
                    position: $(this).data('position'),
                    popup: $(this)
                };
            }).toArray());
        }

        var selectedKey = null;

        // initialize map
        var map = $map.leaflet(markers, function (marker) {
            return marker.id == 'eden-rock' || !selectedKey || marker.options.type == selectedKey;
        });

        if ($key.length) {
            // update map on key change
            $key.on('change', function () {
                selectedKey = $(this).find('input[name="key"]:checked').val();
                map._validateMarkers();
            });
        }

        // recalculate map size on print
        printWatcher.onChange(function () {
            map._resize();
        });

        // recalculate map size on tab change
        tabWatcher.onChange($(this)[0], function () {
            map._resize();
        });
    });
}

function initPropertyListing() {
    if ($('.property-listing').length === 0) {
        return;
    }

    function removeEmpty(obj) {
        return Object.fromEntries(Object.entries(obj).filter(function (v) {
            return v[1] != null && v[1] != '' && (!Array.isArray(v[1]) || v[1].length > 0);
        }));
    }

    function writeQueryString() {
        var datePicker = $('.property-listing__filters-datepicker').easepick();
        var startDate = datePicker.getStartDate();
        var endDate = datePicker.getEndDate();

        var data = {
            view: $('.property-listing__views input[name="property-listing-view"]:checked').val(),
            name: $('.property-listing__filters-field[name="villa-name"]').val(),
            minPrice: $('.property-listing__filters-dropdown[name="min-price"]').val(),
            maxPrice: $('.property-listing__filters-dropdown[name="max-price"]').val(),
            categories: Multiselect.getValues($('.property-listing__filters-multiselect[data-name="categories"]')[0]),
            facilities: Multiselect.getValues($('.property-listing__filters-multiselect[data-name="facilities"]')[0]),
            locations: Multiselect.getValues($('.property-listing__filters-multiselect[data-name="locations"]')[0]),
            rooms: Multiselect.getValues($('.property-listing__filters-multiselect[data-name="rooms"]')[0]),
            fromDate: startDate && startDate.format('YYYY-MM-DD'),
            toDate: endDate && endDate.format('YYYY-MM-DD')
        };

        // defaults
        if (data.view == "list") {
            data.view = null;
        }

        data = removeEmpty(data);

        var searchParams = new URLSearchParams();

        Object.keys(data).forEach(function (key) {
            var value = data[key];
            if (Array.isArray(value)) {
                value.forEach(function (valueItem) {
                    searchParams.append(key, valueItem);
                });
            } else {
                searchParams.append(key, value);
            }
        });

        var searchParamsStr = searchParams.toString();

        var newUrl = window.location.origin + window.location.pathname;

        if (searchParamsStr.length > 0) {
            newUrl += '?' + searchParamsStr;
        }

        // so we can identify this is a property listing popstate event
        data["source"] = "property listing";

        if (newUrl != window.location.href) {
            window.history.pushState(data, '', newUrl);
        }
    }

    function readQueryString(data) {
        var searchParams = new URLSearchParams(window.location.search);

        var data = data || {
            view: searchParams.get("view"),
            name: searchParams.get("name"),
            minPrice: searchParams.get("minPrice"),
            maxPrice: searchParams.get("maxPrice"),
            categories: searchParams.getAll("categories"),
            facilities: searchParams.getAll("facilities"),
            locations: searchParams.getAll("locations"),
            rooms: searchParams.getAll("rooms"),
            fromDate: searchParams.get("fromDate"),
            toDate: searchParams.get("toDate")
        };

        $('.property-listing__views input[name="property-listing-view"][value="' + (data.view || "list") + '"]').prop('checked', true);
        $('.property-listing__filters-field[name="villa-name"]').val(data.name);
        $('.property-listing__filters-dropdown[name="min-price"]').val(data.minPrice);
        $('.property-listing__filters-dropdown[name="max-price"]').val(data.maxPrice);
        Multiselect.setValues($('.property-listing__filters-multiselect[data-name="categories"]')[0], data.categories || []);
        Multiselect.setValues($('.property-listing__filters-multiselect[data-name="facilities"]')[0], data.facilities || []);
        Multiselect.setValues($('.property-listing__filters-multiselect[data-name="locations"]')[0], data.locations || []);
        Multiselect.setValues($('.property-listing__filters-multiselect[data-name="rooms"]')[0], data.rooms || []);

        var datePicker = $('.property-listing__filters-datepicker').easepick();

        if (data.fromDate) {
            datePicker.setStartDate(new Date(data.fromDate));
        } else if (datePicker.getStartDate() != null) {
            datePicker.clear();
        }

        if (data.toDate) {
            datePicker.setEndDate(new Date(data.toDate));
        } else if (datePicker.getEndDate() != null) {
            datePicker.clear();
        }
    }

    var villaVisibility = {};

    var selectedName = $('.property-listing__filters-field[name="villa-name"]');
    var selectedMinPrice = $('.property-listing__filters-dropdown[name="min-price"]');
    var selectedMaxPrice = $('.property-listing__filters-dropdown[name="max-price"]');
    var selectedCategories = $('.property-listing__filters-multiselect[data-name="categories"]');
    var selectedFacilities = $('.property-listing__filters-multiselect[data-name="facilities"]');
    var selectedLocations = $('.property-listing__filters-multiselect[data-name="locations"]');
    var selectedRooms = $('.property-listing__filters-multiselect[data-name="rooms"]');

    var selectedArrivalDate = null;
    var selectedDepartureDate = null;

    var map = null;

    var $propertyListingMap = $('#property-listing-map');

    if ($propertyListingMap.length > 0) {
        var markers = $propertyListingMap.data('map').markers || [];

        // map markers
        markers = markers.concat($('.property-listing__map-marker').map(function () {
            return {
                id: $(this).data('id'),
                icon: $(this).data('icon'),
                position: $(this).data('position'),
                popup: $(this)
            };
        }).toArray());

        // initialize map
        map = $propertyListingMap.leaflet(markers, function (marker) {
            return marker.id == 'eden-rock' || villaVisibility[marker.id];
        });
    }

    var selectedView = $('.property-listing__views input[name="property-listing-view"]:checked').val();

    // change view after selecting view option
    $('.property-listing__views input[name="property-listing-view"]').on('change', function () {
        // set the selected view
        selectedView = $(this).val();

        // replace old listing class with new one
        $('.property-listing')[0].className = $('.property-listing')[0].className.split(' ').map(function (c) {
            return c.startsWith('property-listing--') ? 'property-listing--' + selectedView : c;
        }).join(' ');

        writeQueryString();

        // trigger resize event
        $('.property-listing__wrapper').trigger('resized');

        if (map && selectedView == 'map') {
            map._resize();
        }
    });

    // trigger resize event
    $('.property-listing__filters').on('opened.zf.offcanvas closed.zf.offcanvas', function () {
        $('.property-listing__wrapper').trigger('resized');
    });

    $('.property-listing__wrapper').on('resized', function () {
        // make sure the off canvas wrapper is at least the height of the filter pane
        var wrapper = $(this);
        var offCanvas = wrapper.find('.property-listing__filters');
        wrapper.css('min-height', offCanvas.height() + 30);

        // resize the map
        if (map) {
            map.invalidateSize();
        }
    });

    var picker = $('.property-listing__filters-datepicker').easepick();

    picker.on('select', function (e) {
        selectedArrivalDate = e.detail.start;
        selectedDepartureDate = e.detail.end;
		
		selectedArrivalDate.setUTCHours(0);
		selectedDepartureDate.setUTCHours(0);
		
        filterProperties(true);
    });

    picker.on('clear', function () {
        selectedArrivalDate = null;
        selectedDepartureDate = null;
        filterProperties(true);
    });

    function filterProperties(writeQs) {
        writeQs && writeQueryString();

        // prevent invalid max price
        selectedMaxPrice.find('option').each(function () {
            var disabled = parseInt($(this).val()) < parseInt(selectedMinPrice.val());
            $(this).prop('disabled', disabled);
            $(this).prop('selected', !disabled && $(this).is(':selected'));
        });

        // get selected filters
        var filterName = selectedName.val();
        var filterMinPrice = parseInt(selectedMinPrice.val() || '0');
        var filterMaxPrice = parseInt(selectedMaxPrice.val() || '0');
        var filterCategories = Multiselect.getValues(selectedCategories[0]);
        var filterFacilities = Multiselect.getValues(selectedFacilities[0]);
        var filterLocations = Multiselect.getValues(selectedLocations[0]);
        var filterRooms = Multiselect.getValues(selectedRooms[0]);
        var filterArrivalDate = selectedArrivalDate;
        var filterDepartureDate = selectedDepartureDate;

        var favourites = JSON.parse(window.localStorage.getItem('favourites')) || [];

        // apply filters to all listed villas
        var villas = $('.property-listing__item');

        villas.each(function () {
            var villa = $(this);

            var valid = true;

            var id = villa.data('id');
            var name = villa.data('name');
            var price = villa.data('price');
            var categories = villa.data('categories').split(',');
            var facilities = villa.data('facilities').split(',');
            var location = villa.data('location').split(',');
            var rooms = villa.data('rooms').toString().split(',');
            var disabledDates = villa.data('disabled-dates');

            if (filterName && name) {
                valid = filterName.split(' ').every(function (term) {
                    return name.toLowerCase().includes(term.toLowerCase());
                });
            }

            if (valid && ((filterMinPrice && price < filterMinPrice) || (filterMaxPrice && price > filterMaxPrice))) {
                valid = false;
            }

            if (valid && filterCategories && filterCategories.length > 0 && categories) {
                valid = Array.from(categories).some(function (x) { return filterCategories.includes(x); });
            }

            if (valid && filterFacilities && filterFacilities.length > 0 && facilities) {
                valid = filterFacilities.every(function (x) { return facilities.includes(x); });
            }

            if (valid && filterLocations && filterLocations.length > 0 && location) {
                valid = Array.from(location).some(function (x) { return filterLocations.includes(x); });
            }

            if (valid && filterRooms && filterRooms.length > 0 && rooms) {
                valid = Array.from(rooms).some(function (x) { return filterRooms.includes(x); });
            }

            if (valid && filterArrivalDate && filterDepartureDate && disabledDates && disabledDates.length > 0) {
                // check that villa doesn't have disabled periods during the selected arrival and departure dates
                disabledDates.forEach(function (dd) {
                    var startDate = new Date(dd.start + 'T00:00');
                    var endDate = new Date(dd.end + 'T00:00');

                    if (
                        (filterArrivalDate >= startDate && filterArrivalDate < endDate) ||
                        (filterDepartureDate > startDate && filterDepartureDate <= endDate) ||
                        (filterArrivalDate < startDate && filterDepartureDate > endDate)
                    ) {
                        valid = false;
                    }
                });
            }

            if (selectedView === 'loved') {
                valid = favourites.includes(id);
            }

            // toggle visibility class based on filter checks
            villa.toggleClass('property-listing__item--hidden', !valid);

            villaVisibility[id] = valid;
        });

        // update map markers
        if (map) {
            map._validateMarkers();
        }

        // get the number of valid items
        var numVisibleVillas = villas.not('.property-listing__item--hidden').length;

        // show message when no matches have been found
        $('.no-results').removeClass('no-results--active');

        if (numVisibleVillas === 0) {
            $('.no-results--' + selectedView).addClass('no-results--active');
        }
    }

    $('.property-listing__views input[name="property-listing-view"], .property-listing__filters-field, .property-listing__filters-dropdown, .property-listing__filters-multiselect').on('change', function () {
        filterProperties(true);
    });

    window.addEventListener("popstate", function (event) {
        if (event.state && event.state["source"] == "property listing") {
            readQueryString(event.state);
        }
    });

    readQueryString();

    filterProperties(false);
}

function initContactForm() {
    $('.contact-form__date input').each(function () {
        var form = $(this).closest('form');
        var arrivalDate = form.find('input[name="arrivalDate"]');
        var departureDate = form.find('input[name="departureDate"]');

        var picker = $(this).easepick({
            RangePlugin: {
                startDate: arrivalDate.val(),
                endDate: departureDate.val()
            }
        });

        picker.on('select', function (e) {
            arrivalDate.val(e.detail.start.toISOString());
            departureDate.val(e.detail.end.toISOString());
        });

        picker.on('clear', function () {
            arrivalDate.val(null);
            departureDate.val(null);
        });
    });
}

function initFavourites() {
    var favourites = JSON.parse(localStorage.getItem('favourites')) || [];
    var favouriteButtons = $('[data-favourite]');
    var lovedVillasButton = $('header .loved-villas-button');
    var lovedVillasButtonText = lovedVillasButton.find('.loved-villas-button__count');

    favouriteButtons.on('click', function (e) {
        e.preventDefault();
        // get id from data attr
        var id = $(this).data('favourite');
        // update loved villas list
        addOrRemove(id);
        // update button states
        updateState();
    });

    function addOrRemove(id) {
        // check if it exists in the list
        var exists = favourites.includes(id);
        // remove if exists, else add
        if (exists) {
            favourites.splice(favourites.indexOf(id), 1);
        } else {
            favourites.push(id);
        }
        // update array in localstorage
        localStorage.setItem('favourites', JSON.stringify(favourites));
    }

    function updateState() {
        // update loved villas button
        lovedVillasButtonText.html(favourites.length + ' ');
        lovedVillasButton.toggleClass('toggled', !!favourites.length);
        // update favourite buttons
        favouriteButtons.each(function () {
            var id = $(this).data('favourite');
            $(this).toggleClass('toggled', favourites.includes(id));
        });
    }

    updateState();
}

function initHero() {
    var videoMobile = $('.mobile-hero-video')
    var videoDesktop = $('.desktop-hero-video')
    if (window.innerWidth > 640) {
        videoDesktop.attr('src', videoDesktop.data('src'))
    } else {
        videoMobile.attr('src', videoMobile.data('src'))
    }
}

function initIntro() {
    // toggle second intro text block
    $('.intro__more button').on('click', function () {
        var btn = $(this);
        var div = btn.parent('.intro__more');
        var showLess = !div.hasClass('intro__more--less');

        div.prev('.intro__text').toggleClass('intro__text--more');
        div.toggleClass('intro__more--less');

        btn.text(showLess ? btn.data('less') : btn.data('more'));
    });
}

function initGallery() {
    $('.gallery-modal')
        .on('open.zf.reveal', function (e) {
            $('body').addClass('gallery-modal-open');

            $(this)
                .find('img[data-src]')
                .each(function (i, el) {
                    $(el)
                        .attr('src', $(el).data('src'))
                        .removeAttr('data-src');
                });

            $(this)
                .find('iframe[data-src]')
                .each(function (i, el) {
                    $(el).attr('src', $(el).data('src'));
                });

            var slider = $(this).find('.slider');

            slider
                .not('.slick-initialized')
                .slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: true,
                    infinite: false,
                    prevArrow: '<button type="button" class="control-arrow normal control-prev control-prev--light"></button>',
                    nextArrow: '<button type="button" class="control-arrow normal control-next control-next--light"></button>'
                })
                .slick('slickFilter', ':not(.hide)')
                .on('afterChange', function (e) {
                    var slick = $(this).slick('getSlick');

                    var autoplayVideos = $(window).outerWidth() >= 900;

                    slick.$slides.each(function (i, slide) {
                        if (i === slick.currentSlide) {
                            // start video on current slide
                            if (autoplayVideos) {
                                var video = $(slide).find('video.mejs__player');

                                if (video.length > 0) {
                                    video.data('mediaelementplayer').load();
                                }
                            }
                        } else {
                            // pause video on hidden slide
                            var video = $(slide).find('video.mejs__player');

                            if (video.length > 0) {
                                video.data('mediaelementplayer').pause();
                            }
                        }
                    });
                });

            var videos = slider.find('video.mejs__player');

            if (videos.length > 0) {
                videos.data('mediaelementplayer').load();
            }

            slider.slick('slickGoTo', $(this).data('start-slide-index') || 0, true);

            slider.slick('refresh');

            $(this).trigger('resizeme.zf.trigger');
        })
        .on('closed.zf.reveal', function (e) {
            $('body').removeClass('gallery-modal-open');
            $(this)
                .find('iframe[data-src]')
                .attr('src', '');
        });

    $('[data-open][data-slide-index]').on('click', function (e) {
        var modal = $('#' + $(this).data('open'));
        modal.data('start-slide-index', $(this).data('slide-index'));
    });

    // show images on mobile when they come into view
    $('.small-gallery img[data-scroll]').on('scrollme.zf.trigger', function (e, target, scroll) {
        if (target.offset().top - 100 > scroll + window.innerHeight) {
            // still out of view
            return;
        }
        // coming into view, so load image
        target.off('scrollme.zf.trigger');
    });

    var scrollTop = $(window).scrollTop();

    $('.small-gallery img[data-scroll]').each(function () {
        var el = $(this);
        el.trigger('scrollme.zf.trigger', [el, scrollTop]);
    });
}

function initRatesTables() {
    var timer;

    function debounce(target) {
        clearTimeout(timer);
        timer = setTimeout(target, 250);
    }

    var $tabs = $('.rates [data-tabs]');

    if ($tabs.length) {
        $(window).on('load resize orientationchange', function () {
            // debounce to avoid initializing slick multiple times
            debounce(function () {
                // get each set of rate table tabs
                $tabs.each(function () {
                    if ($(window).width() < 1024) {
                        // ensure slick is not already initialized
                        if (!$(this).hasClass('slick-initialized')) {
                            // initialize slick
                            var slider = $(this).slick({
                                arrows: true,
                                draggable: true,
                                infinite: false,
                                mobileFirst: true,
                                slidesToShow: 1
                            });

                            // select tab on slide change
                            slider.on('beforeChange', function (e, slick, currentSlide, nextSlide) {
                                slick.$slides.get(nextSlide).click();
                            });

                            // get current rate table tab
                            var activeTab = $('.rates [data-tabs-content="' + $(this).prop('id') + '"] .is-active');

                            // set slick slide to current tab
                            if (activeTab) {
                                $(this).slick('slickGoTo', activeTab.index());
                            }
                        }
                    } else if ($(this).hasClass('slick-initialized')) {
                        $(this).slick('unslick');
                    }
                });
            });
        });
    }
}

function initVideos() {
    // start video when clicking play button
    $('.video__play').on('click', function () {
        var btn = $(this);
        var wrapper = btn.closest('.video__wrapper');
        var video = btn.next('.video__video').find('video');
        var iframe = btn.next('.video__video').find('iframe');

        if (video.length === 1) {
            video.get(0).play();
        } else if (iframe.length === 1) {
            iframe.attr('src', iframe.data('src'));
        }

        wrapper.addClass('video__wrapper--playing');
    });
}

function initYourStay() {
    $('.your-stay').each(function () {
        var el = $(this);

        var arrivalDate = el.find('.enquiry-form__field--arrive');
        var arrivalDay = el.find('.enquiry-form__output--arrive .enquiry-form__output__day');
        var arrivalMonth = el.find('.enquiry-form__output--arrive .enquiry-form__output__month-year');

        var departureDate = el.find('.enquiry-form__field--depart');
        var departureDay = el.find('.enquiry-form__output--depart .enquiry-form__output__day');
        var departureMonth = el.find('.enquiry-form__output--depart .enquiry-form__output__month-year');

        var datePicker = el.parent().find('.inline-datepicker');

        var picker = datePicker.easepick({
            grid: 2,
            calendars: 4,
            inline: true,
            pending: datePicker.data('pending') || [],
            unavailable: datePicker.data('unavailable') || [],
            AmpPlugin: {
                resetButton: false,
                darkMode: false
            }
        });

        picker.on('select', function (e) {
            el.removeClass('hide');

            var monthYearFormatter = new Intl.DateTimeFormat(config.culture, {
                year: 'numeric',
                month: 'long'
            });

            arrivalDate.val(e.detail.start.toISOString());
            arrivalDay.text(e.detail.start.getDate());
            arrivalMonth.text(monthYearFormatter.format(e.detail.start));

            departureDate.val(e.detail.end.toISOString());
            departureDay.text(e.detail.end.getDate());
            departureMonth.text(monthYearFormatter.format(e.detail.end));
        });
    });
}

var Multiselect = (function () {
    function getValues(multiselect) {
        if (multiselect) {
            var checked = multiselect.querySelectorAll('input[type=checkbox]:checked');
            return Array.from(checked).map(function (e) {
                return e.value;
            });
        }
    }

    function setValues(multiselect, values) {
        if (multiselect) {
            clearSelection(multiselect);

            var selector = values.map(function (value) {
                return 'input[type=checkbox][value="' + CSS.escape(value) + '"]';
            }).join(',');

            if (selector) {
                multiselect.querySelectorAll(selector).forEach(function (e) {
                    e.checked = true;
                });
            }
        }
    }

    function emitChangeEvent(multiselect) {
        var event = new CustomEvent('change', {
            bubbles: false,
            cancelable: false,
            detail: {
                getValues: function () {
                    return getValues(multiselect);
                }
            }
        });

        multiselect.dispatchEvent(event);
    }

    function selectAll(multiselect) {
        var unchecked = multiselect.querySelectorAll('input[type=checkbox]:not(:checked)');
        if (unchecked.length > 0) {
            unchecked.forEach(function (e) {
                e.checked = true;
            });
        }
    }

    function clearSelection(multiselect) {
        var checked = multiselect.querySelectorAll('input[type=checkbox]:checked');
        if (checked.length > 0) {
            checked.forEach(function (e) {
                e.checked = false;
            });
        }
    }

    function init() {
        var multiselects = document.querySelectorAll('.er-multiselect');

        multiselects.forEach(function (e, i) {
            // setup select all and clear buttons
            var selectAllButton = e.querySelector('.er-multiselect__button--select-all');
            if (selectAllButton) {
                selectAllButton.addEventListener('click', function () {
                    selectAll(e);
                    emitChangeEvent(e);
                });
            }

            var clearSelectionButton = e.querySelector('.er-multiselect__button--clear');
            if (clearSelectionButton) {
                clearSelectionButton.addEventListener('click', function () {
                    clearSelection(e);
                    emitChangeEvent(e);
                });
            }

            // bubble up change events
            e.querySelectorAll('input[type=checkbox]').forEach(function (item) {
                item.addEventListener('change', function (ev) {
                    ev.detail = {
                        getValues: function () {
                            return getValues(e);
                        }
                    };
                });
            });

            // handle window overflow
            e.addEventListener('toggle', function (ev) {
                if (e.open) {
                    var fieldset = e.querySelector('fieldset');
                    var bounding = fieldset.getBoundingClientRect();
                    if (bounding.top + bounding.height > window.innerHeight) {
                        fieldset.style.bottom = e.offsetHeight + 'px';
                    }
                }
            });

            // handle de-focus
            e.addEventListener('focusout', function (ev) {
                if (e.open && ev.relatedTarget && e != ev.relatedTarget && !e.contains(ev.relatedTarget)) {
                    e.open = false;
                }
            });
        });

        // handle de-focus when clicking outside
        document.addEventListener('click', function (ev) {
            var target = ev.relatedTarget || ev.target;
            var isOutside = target.closest('.er-multiselect') == null;

            if (isOutside) {
                multiselects.forEach(function (e, i) {
                    e.open = false;
                });
            }
        });
    }

    return {
        init: init,
        getValues: getValues,
        setValues: setValues,
        selectAll: selectAll,
        clearSelection: clearSelection
    };
})();

var initVpCenter = function() { 
  
    const $vpCenterElement = $('.vp-center').first();
    

    if ($vpCenterElement.length) {
       
        const justifyContent = $vpCenterElement.css('justify-content');
        
   
        if (justifyContent === 'center') {
    
            $vpCenterElement.css('justify-content', 'flex-start');
        }
    }
}


function initSliderVideo() {

    if ($('.slider__slide').length > 0) {
        // Make sure the slider always fills the whole screen
        coverViewport($('.slider__slide iframe'), true);
        $(window).on('resize', function () {
            setTimeout(function () {
            coverViewport($('.slider__slide iframe'), true);
            }, 300)
        });
    }
}



function coverViewport(element, scaleToParent) {
	if (typeof scaleToParent === 'undefined') { scaleToParent = false; }

	var viewportWidth, viewportHeight;
	if (scaleToParent) {
		viewportWidth = $(element).parent().innerWidth();
		viewportHeight = $(element).parent().innerHeight();
	} else {
		viewportWidth = $(window).innerWidth();
		viewportHeight = $(window).innerHeight();
	}

	var $element = $(element);

	var elementWidth = $element.attr('width');
	var elementHeight = $element.attr('height');

	// Aspect ratio = height / width
	var viewportRatio = viewportHeight / viewportWidth;
	var videoRatio = elementHeight / elementWidth;

	//console.log('Viewport: ', viewportRatio, ' Video: ', videoRatio);


	var newWidth = (elementWidth / elementHeight) * viewportHeight
	var newHeight = (elementHeight / elementWidth) * viewportWidth;
	var newTop = 0;

	if (viewportRatio > videoRatio) {
		// set video height to the viewport, and extend the video beyond the viewport width, i.e. portrait viewport
		//console.log('crop left and right');
		$element.css('height', viewportHeight);
		$element.css('width', newWidth);
		$element.css('left', '-' + (newWidth - viewportWidth) / 2 + 'px');
		$element.css('top', '0');
	} else if (viewportRatio < videoRatio) {
		// set video width to the viewport, and extend the video beyond the viewport height, i.e. landscape viewport
		//console.log('crop top and bottom');
		$element.css('width', viewportWidth);
		$element.css('height', newHeight);
		$element.css('left', '0');
		$element.css('top', '-' + (newHeight - viewportHeight) / 2 + 'px');
	} else {
		// set the video width AND height to the viewport size, i.e. viewport is the same ratio as the video
		//console.log('no crop');
		$element.css('height', viewportHeight);
		$element.css('width', viewportWidth);
		$element.css('left', '0');
		$element.css('top', '0');
	}
}
